var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSearch = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  strokeWidth: 0.5,
  d: "M16.634 17.695a8.75 8.75 0 1 1 1.06-1.06l3.836 3.835a.75.75 0 0 1-1.06 1.06zm-.427-1.65a7.25 7.25 0 1 0-.163.163.8.8 0 0 1 .163-.163"
})));
export default SvgSearch;